import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ILeaderboard} from "../types";

// Define a type for the slice state
interface LeaderboardState {
  value?: ILeaderboard[];
}

// Define the initial state using that type
const initialState: LeaderboardState = {
  value: undefined,
} as LeaderboardState;

export const leaderboardSlice = createSlice({
  name: 'leaderboard',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLeaderboard: (state, action: PayloadAction<ILeaderboard[]>) => {
      state.value = action.payload;
    },
  },
});

export const {setLeaderboard} = leaderboardSlice.actions;

// Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value;

export default leaderboardSlice.reducer;
